import {isMobile} from "react-device-detect";
import {config} from "../../config";

function ManaCost({costs, level, isVeryBigSize, isBigSize}) {

    let manaCosts = costs;

    if (typeof costs === 'string') {
        manaCosts = JSON.parse(manaCosts);
    }

    let manaCostSizeClass = 'manaCostNormal';
    if (isVeryBigSize !== false) {
        manaCostSizeClass = 'manaCostVeryBig';
    }
    if (isBigSize !== false) {
        manaCostSizeClass = 'manaCostBig';
    }

    let ManaCostBaseClass = 'manaCostItem';

    if(isMobile && !config.isAndroid){
         ManaCostBaseClass = 'manaCostItemMobile';
    }

    return (
        <div className='manaCost'>
            {Object.keys(manaCosts).map((item, index) => {
                return <div key={index}
                            className={manaCostSizeClass + ' ' + ManaCostBaseClass + ' font-oswald-bold ' + item + 'Card ' + item + 'Card-' + level}>
                    <div>{manaCosts[item]}</div>
                </div>
            })}

        </div>
    );
}

export default ManaCost;